import React, { useState, useEffect, useRef } from 'react'
import { Button, Select, Row, Col } from 'antd'
import { API, sendDataBody } from '../../resources'
import Loading from '../../loading'
import { usuario } from '../../resources'
import Expedientes from '../expedientes/expedientes'
// import DetallesPaciente from './detalles.paciente_old'
// import DetallesPaciente from './detalles.paciente'
import Register from './register.patient'
import { PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs'
import ExpedienteFisio from '../expedieteFisio/expediente'
import RegisterFisio from './register.patent.fisio'
import CodeGenerate from './code.generate'
const { Option } = Select;

export default function MainPacientes() {

  const TIPO = usuario.tipo || "PSIQ"

  const [pacientesData, setPacientesData] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const [activePatient, setActivePatient] = useState(pacientesData[0]?._id)

  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false) // PSIQ
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [isRegisterFisioModal, setIsRegisterFisioModal] = useState(false) // FISIO
  const [isEditFisioModalOpen, setIsEditFisioModalOpen] = useState(false)

  const initialPacientesRef = useRef([])
  const wasAnyModalOpenRef = useRef(false)

  const formatPacientes = (data) => {
    data.forEach(paciente => {
      if (paciente.responsable) {
        paciente.res_name = paciente.responsable.nombre;
        paciente.res_phone = paciente.responsable.telefono;
      }
      paciente.fecha_nacimiento = dayjs(paciente.fecha_nacimiento);
    });
    return data
  }

  useEffect(() => {
    getPacientesData()
  }, [])

  useEffect(() => {
    // Solo recargar la lista completa al CERRAR un modal de REGISTRO (alta de
    // paciente nuevo), no al editar: pacientes/medicos/first solo trae los 30
    // mas recientes, asi que si el paciente activo vino de una busqueda podria
    // no estar en esa lista y se perderia el foco. Al editar, el paciente ya
    // esta en pacientesData, asi que se actualiza localmente (updatePatientLocally)
    // en vez de refrescar todo.
    const isAnyRegisterModalOpen = isRegisterModalOpen || isRegisterFisioModal
    if (wasAnyModalOpenRef.current && !isAnyRegisterModalOpen) {
      getPacientesData()
    }
    wasAnyModalOpenRef.current = isAnyRegisterModalOpen
  }, [isRegisterModalOpen, isRegisterFisioModal])

  // Al editar un paciente ya lo tenemos completo en el cliente (los valores
  // que se acaban de enviar al PUT), asi que solo se actualiza ese registro
  // en memoria en vez de volver a pedir la lista (evita perder el foco, ver
  // nota arriba, y refleja el cambio de inmediato sin esperar al servidor).
  const updatePatientLocally = (id, updatedFields) => {
    const mergePaciente = (paciente) => {
      const merged = { ...paciente, ...updatedFields }
      if (merged.responsable) {
        merged.res_name = merged.responsable.nombre
        merged.res_phone = merged.responsable.telefono
      }
      if (updatedFields.fecha_nacimiento) {
        merged.fecha_nacimiento = dayjs(updatedFields.fecha_nacimiento)
      }
      return merged
    }
    setPacientesData(prev => prev.map(p => p._id === id ? mergePaciente(p) : p))
    setActivePatient(prev => (prev && prev._id === id) ? mergePaciente(prev) : prev)
  }

  const getPacientesData = () => {
    sendDataBody('pacientes/medicos/first', { medicos: [usuario._id] })
      .then(data => {
        formatPacientes(data)
        initialPacientesRef.current = data
        setPacientesData(data);
        if (data && data.length > 0) {
          const current = activePatient?._id
            ? data.find(p => p._id === activePatient._id) ?? data[0]
            : data[0]
          setActivePatient(current)
        }
      })
      .finally(() => setIsLoading(false))
  }




  const onChange = (data) => {
    const found = pacientesData.find(p => p._id === data)
    setActivePatient(found)
    console.log('active patient', found)
  };

  const onChangePhone = (data) => {
    const found = pacientesData.find(p => p.telefono === data)
    setActivePatient(found)
    console.log('active patient', found)
  };

  const onSearch = (value) => {
    if (!value) {
      setPacientesData(initialPacientesRef.current)
      return
    }
    sendDataBody('pacientes/medicos/search/name', {
      medicos: [usuario._id],
      search: value,
    }).then((data) => {
      formatPacientes(data)
      setPacientesData(data)
    })
  };

  const onSearchPhone = (value) => {
    if (!value) {
      setPacientesData(initialPacientesRef.current)
      return
    }
    sendDataBody('pacientes/medicos/search/phone', {
      medicos: [usuario._id],
      phone: value,
    }).then((data) => {
      formatPacientes(data)
      setPacientesData(data)
    })
  };

  if (isLoading) return <Loading />


  return (
    <div className='mainContainer' style={{ backgroundColor: '#f5f6f8' }}>
      {/* <Col ></Col> */}
      <h3 >Pacientes</h3>
      <Row justify="start">
        <Col>
          <div className="my-select-container">
            <Select
              // Widget para buscar pacientes
              style={{ borderRadius: 8, width: 380 }}
              dropdownStyle={{ borderRadius: 8 }}
              showSearch
              placeholder="Buscar paciente"
              optionFilterProp="children"
              onChange={onChange}
              onSearch={onSearch}
              filterOption={false}
              allowClear
              onClear={getPacientesData}
            >
              {
                pacientesData.map((p) => <Option key={p._id} value={p._id}>{p.name}</Option>)
              }
            </Select>
          </div>
        </Col>
        <Col>
          <div className="my-select-container">
            <Select
              // Buscar pacientes por numero de telefono
              style={{ borderRadius: 8, width: 360, marginLeft: 12 }}
              dropdownStyle={{ borderRadius: 8 }}
              showSearch
              placeholder="Buscar por telefono"
              optionFilterProp="children"
              onChange={onChangePhone}
              onSearch={onSearchPhone}
              filterOption={false}
              allowClear
              onClear={getPacientesData}
            >
              {
                pacientesData.map((p) => <Option key={p._id} value={p.telefono}>{p.telefono} {p.name}</Option>)
              }
            </Select>
          </div>
        </Col>
        <Col style={{ marginLeft: 12 }}>
          {TIPO === 'FISIO' ?
            <div className='fila'>
              <Button className='btnIconCentered' style={{ height: 30 }} onClick={() => setIsRegisterFisioModal(!isRegisterFisioModal)} size='small' icon={<PlusOutlined />} shape='round' type="primary"  >Agregar Paciente</Button>
              <CodeGenerate />
            </div>
            :
            <Button className='btnIconCentered' style={{ height: 30 }} onClick={() => setIsRegisterModalOpen(!isRegisterModalOpen)} size='small' icon={<PlusOutlined />} shape='round' type="primary" title='Agregar paciente' >Agregar Paciente</Button>
          }
        </Col>
      </Row> <div style={{ height: '16px' }}></div>


      {
        TIPO === 'FISIO' ?
          <ExpedienteFisio paciente={activePatient} setIsEditModalOpen={setIsEditFisioModalOpen} /> :
          <div>{
            pacientesData.length === 0 ? <div style={{ padding: 12, width: '100%', height: 400, borderRadius: 12, backgroundColor: 'white' }} className='nombre'>Sin pacientes registrados</div> :
              < Expedientes paciente={activePatient} setIsEditModalOpen={setIsEditModalOpen} />
          }
          </div>
      }

      {/* Modal For Register */}
      <Register setIsModalOpen={setIsRegisterModalOpen} isModalOpen={isRegisterModalOpen} getPacientesData={getPacientesData} />

      {/* Modal For Edit */}
      <Register setIsModalOpen={setIsEditModalOpen} isModalOpen={isEditModalOpen} paciente={activePatient} updatePatientLocally={updatePatientLocally} />

      {/* Modal For Register FISIO*/}
      <RegisterFisio setIsModalOpen={setIsRegisterFisioModal} isModalOpen={isRegisterFisioModal} getPacientesData={getPacientesData} />

      {/* Modal For Edit FISIO*/}
      <RegisterFisio setIsModalOpen={setIsEditFisioModalOpen} isModalOpen={isEditFisioModalOpen} updatePatientLocally={updatePatientLocally} paciente={activePatient} />

    </div >
  )

}
